import { render, staticRenderFns } from "./ActivityLogIndex.vue?vue&type=template&id=35e80b28"
import script from "./ActivityLogIndex.vue?vue&type=script&lang=js"
export * from "./ActivityLogIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports